module.exports = __webpack_public_path__ + "static/media/wizard-original.ad58925e.png";